import React, { useRef } from "react";
import PropTypes from "prop-types";
import clsx from "clsx";
import Typography from "@material-ui/core/Typography";
import Grid from "@material-ui/core/Grid";
import Paper from "@material-ui/core/Paper";
import { List, ListItemText, ListItem, ListItemIcon } from "@material-ui/core";
import AddIcon from "@material-ui/icons/Add";
import RemoveIcon from "@material-ui/icons/Remove";
import { withStyles } from "@material-ui/core/styles";

/*
export default function ContractTips(props) {
  //const classes = useStyles();
  //const balancePaper = clsx(classes.paper, classes.balanceCard);
  let contract_choices = props.currentContext.contractChoice;
  let infoDict = props.currentContext.contractInformation;
  let containerVal = 6;

  if (props.printout) {
    containerVal = 12;
  }

  return (
    <Grid container>
      {props.currentContext.contractNames.map(
        (elem) =>
          props.currentContext.contractChoice[elem] && (
            <div>
              <Grid
                item
                xs={6}
                key={props.currentContext.contractNames.indexOf(elem)}
                justify="center"
                spacing={1}
                style={{ alignItems: "flex-start", textAlign: "center" }}
              >
                <Typography align="center">{elem}</Typography>
                <Paper className={props.balancePaper}>
                  <Grid item xs={12}>
                    <div>
                      <List dense>
                        {infoDict[elem]["APPLICATION"].map((Application) => (
                          <ListItem
                            key={infoDict[elem]["APPLICATION"].indexOf(
                              Application
                            )}
                          >
                            <ListItemText primary={Application} />
                          </ListItem>
                        ))}
                      </List>
                    </div>
                  </Grid>
                  <Grid item xs={12}>
                    <div>
                      <List dense>
                        {infoDict[elem]["Tips"].map((Tip) => (
                          <ListItem key={infoDict[elem]["Tips"].indexOf(Tip)}>
                            <ListItemText primary={Tip} />
                          </ListItem>
                        ))}
                      </List>
                    </div>
                  </Grid>
                  <Grid item container xs={12}>
                    <Grid item xs={6}>
                      <div>
                        <List dense>
                          {infoDict[elem]["BENEFITS"].map((Benefit) => (
                            <ListItem
                              key={infoDict[elem]["BENEFITS"].indexOf(Benefit)}
                            >
                              <ListItemIcon>
                                <AddIcon />
                              </ListItemIcon>
                              <ListItemText primary={Benefit} />
                            </ListItem>
                          ))}
                        </List>
                      </div>
                    </Grid>
                    <Grid item xs={6}>
                      <div>
                        <List dense>
                          {infoDict[elem]["LIMITATIONS"].map((downsides) => (
                            <ListItem
                              key={infoDict[elem]["LIMITATIONS"].indexOf(
                                downsides
                              )}
                            >
                              <ListItemIcon>
                                <RemoveIcon />
                              </ListItemIcon>
                              <ListItemText primary={downsides} />
                            </ListItem>
                          ))}
                        </List>
                      </div>
                    </Grid>
                  </Grid>

                  <Grid item xs={12}>
                    <div>
                      <List dense>
                        {infoDict[elem]["Resources"].map((resources) => (
                          <ListItem
                            key={infoDict[elem]["Resources"].indexOf(resources)}
                          >
                            <ListItemText
                              secondary={
                                <a
                                  href={resources.split(": ")[1]}
                                  target="_blank>"
                                >
                                  {resources.split(": ")[0]}
                                </a>
                              }
                            />
                          </ListItem>
                        ))}
                      </List>
                    </div>
                  </Grid>
                </Paper>
              </Grid>
              {props.printout && <div class="pagebreak" />}
            </div>
          )
      )}
    </Grid>
  );
}
*/
export default function ContractTips(props) {
  //const classes = useStyles();
  //const balancePaper = clsx(classes.paper, classes.balanceCard);
  let contract_choices = props.currentContext.contractChoice;
  let infoDict = props.currentContext.contractInformation;
  let containerVal = 6;

  if (props.printout) {
    containerVal = 12;
  }

  return (
    <>
      {props.printout ? (
        <>
          <Grid item xs={12}>
            {props.currentContext.contractNames.map(
              (elem) =>
                props.currentContext.contractChoice[elem] && (
                  <>
                    <Grid
                      item
                      xs={12}
                      key={props.currentContext.contractNames.indexOf(elem)}
                      justify="center"
                      spacing={2}
                      style={{ alignItems: "flex-start", textAlign: "center" }}
                    >
                      <Typography align="center">{elem}</Typography>
                      <Paper className={props.balancePaper}>
                        <Grid item xs={12}>
                          <div>
                            <List dense>
                              {infoDict[elem]["APPLICATION"].map(
                                (Application) => (
                                  <ListItem
                                    key={infoDict[elem]["APPLICATION"].indexOf(
                                      Application
                                    )}
                                  >
                                    <ListItemText primary={Application} />
                                  </ListItem>
                                )
                              )}
                            </List>
                          </div>
                        </Grid>
                        <Grid item xs={12}>
                          <div>
                            <List dense>
                              {infoDict[elem]["Tips"].map((Tip) => (
                                <ListItem
                                  key={infoDict[elem]["Tips"].indexOf(Tip)}
                                >
                                  <ListItemText primary={Tip} />
                                </ListItem>
                              ))}
                            </List>
                          </div>
                        </Grid>
                        <Grid item container xs={12}>
                          <Grid item xs={6}>
                            <div>
                              <List dense>
                                {infoDict[elem]["BENEFITS"].map((Benefit) => (
                                  <ListItem
                                    key={infoDict[elem]["BENEFITS"].indexOf(
                                      Benefit
                                    )}
                                  >
                                    <ListItemIcon>
                                      <AddIcon />
                                    </ListItemIcon>
                                    <ListItemText primary={Benefit} />
                                  </ListItem>
                                ))}
                              </List>
                            </div>
                          </Grid>
                          <Grid item xs={6}>
                            <div>
                              <List dense>
                                {infoDict[elem]["LIMITATIONS"].map(
                                  (downsides) => (
                                    <ListItem
                                      key={infoDict[elem][
                                        "LIMITATIONS"
                                      ].indexOf(downsides)}
                                    >
                                      <ListItemIcon>
                                        <RemoveIcon />
                                      </ListItemIcon>
                                      <ListItemText primary={downsides} />
                                    </ListItem>
                                  )
                                )}
                              </List>
                            </div>
                          </Grid>
                        </Grid>

                        <Grid item xs={12}>
                          <div>
                            <List dense>
                              {infoDict[elem]["Resources"].map((resources) => (
                                <ListItem
                                  key={infoDict[elem]["Resources"].indexOf(
                                    resources
                                  )}
                                >
                                  <ListItemText
                                    secondary={
                                      <a
                                        href={resources.split(": ")[1]}
                                        target="_blank>"
                                      >
                                        {resources.split(": ")[0]}
                                      </a>
                                    }
                                  />
                                </ListItem>
                              ))}
                            </List>
                          </div>
                        </Grid>
                      </Paper>
                    </Grid>
                    <div class="pagebreak" />
                  </>
                )
            )}
          </Grid>
        </>
      ) : (
        <Grid container>
          {props.currentContext.contractNames.map(
            (elem) =>
              props.currentContext.contractChoice[elem] && (
                <Grid
                  item
                  xs={6}
                  key={props.currentContext.contractNames.indexOf(elem)}
                  justify="center"
                  spacing={2}
                  style={{ alignItems: "flex-start", textAlign: "center" }}
                >
                  <Typography align="center">{elem}</Typography>
                  <Paper className={props.balancePaper}>
                    <Grid item xs={12}>
                      <div>
                        <List dense>
                          {infoDict[elem]["APPLICATION"].map((Application) => (
                            <ListItem
                              key={infoDict[elem]["APPLICATION"].indexOf(
                                Application
                              )}
                            >
                              <ListItemText primary={Application} />
                            </ListItem>
                          ))}
                        </List>
                      </div>
                    </Grid>
                    <Grid item xs={12}>
                      <div>
                        <List dense>
                          {infoDict[elem]["Tips"].map((Tip) => (
                            <ListItem key={infoDict[elem]["Tips"].indexOf(Tip)}>
                              <ListItemText primary={Tip} />
                            </ListItem>
                          ))}
                        </List>
                      </div>
                    </Grid>
                    <Grid item container xs={12}>
                      <Grid item xs={6}>
                        <div>
                          <List dense>
                            {infoDict[elem]["BENEFITS"].map((Benefit) => (
                              <ListItem
                                key={infoDict[elem]["BENEFITS"].indexOf(
                                  Benefit
                                )}
                              >
                                <ListItemIcon>
                                  <AddIcon />
                                </ListItemIcon>
                                <ListItemText primary={Benefit} />
                              </ListItem>
                            ))}
                          </List>
                        </div>
                      </Grid>
                      <Grid item xs={6}>
                        <div>
                          <List dense>
                            {infoDict[elem]["LIMITATIONS"].map((downsides) => (
                              <ListItem
                                key={infoDict[elem]["LIMITATIONS"].indexOf(
                                  downsides
                                )}
                              >
                                <ListItemIcon>
                                  <RemoveIcon />
                                </ListItemIcon>
                                <ListItemText primary={downsides} />
                              </ListItem>
                            ))}
                          </List>
                        </div>
                      </Grid>
                    </Grid>

                    <Grid item xs={12}>
                      <div>
                        <List dense>
                          {infoDict[elem]["Resources"].map((resources) => (
                            <ListItem
                              key={infoDict[elem]["Resources"].indexOf(
                                resources
                              )}
                            >
                              <ListItemText
                                secondary={
                                  <a
                                    href={resources.split(": ")[1]}
                                    target="_blank>"
                                  >
                                    {resources.split(": ")[0]}
                                  </a>
                                }
                              />
                            </ListItem>
                          ))}
                        </List>
                      </div>
                    </Grid>
                  </Paper>
                </Grid>
              )
          )}
        </Grid>
      )}
    </>
  );
}
